module.exports = __webpack_public_path__ + "img/about/80243-001.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-001.jpg
// module id = 11
// module chunks = 0